import React from "react";
import "./Footer.css";
import { BsTwitter, BsLinkedin, BsGithub } from "react-icons/bs";
import {} from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer__fadeTop" />
      <div className="footer__content">
        <div className="links">
          <a
            href="https://www.linkedin.com/in/thepulkitmalhotra/"
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin />
          </a>
          <a
            href="https://twitter.com/PulkitMalhotraa"
            target="_blank"
            rel="noreferrer"
          >
            <BsTwitter />
          </a>
          <a
            href="https://github.com/PulkitMalhotra161001"
            target="_blank"
            rel="noreferrer"
          >
            <BsGithub />
          </a>
        </div>
        <h2 className="name">
          Made with ❤️ by{" "}
          <a href="https://pulkitmalhotra.me/" target="_blank" rel="noreferrer">
            Pulkit Malhotra
          </a>
        </h2>
      </div>
    </div>
  );
};

export default Footer;
